import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/config/constants';
import { PaymentService } from 'src/app/lib/services/payment.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { WalletService } from 'src/app/lib/services/wallet.service';

@Component({
  selector: 'app-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
  standalone: false,
})
export class WalletPageComponent implements OnInit {

  walletBalance: any;
  userId: any;

  constructor(
    private paymentService: PaymentService,
    private storageService: StorageService,
    private walletService: WalletService
  ) { }

  ngOnInit() {
    const userId = '68148eedfb99f03e3a1c791c';
    console.log(userId);
    this.fetchWalletBalance(userId);
  }

  fetchWalletBalance(userId: string) {
    this.walletService.getWalletBalance(userId).subscribe((res) => {
      // console.log('Wallet balance:', res);
      this.walletBalance = res;
    }, (err: any) => {
      console.error('Error fetching wallet balance:', err);
    });
  }

  onWithdraw() {
    const available = this.walletBalance.data.availableBalance;
    if (available > 0) {
      console.log('Withdrawing:', available);
      alert(`Withdrawing ₹${available}`);
    } else {
      alert('No available balance to withdraw.');
    }
  }

  addmoney() {
    console.log('Hello')
  }
}
